// import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// const Failure: React.FC = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [seconds, setSeconds] = useState(8);

//   // Optional: pass error message from payment gateway
//   const errorMessage =
//     (location.state as any)?.message ||
//     "Payment could not be completed. Please try again.";

//   const redirectPath =
//     localStorage.getItem("postLoginRedirect") || "/dashboard";

//   useEffect(() => {
//     const countdown = setInterval(() => {
//       setSeconds((prev) => prev - 1);
//     }, 1000);

//     const autoRedirect = setTimeout(() => {
//       navigate(redirectPath);
//     }, 8000); // change as needed

//     return () => {
//       clearInterval(countdown);
//       clearTimeout(autoRedirect);
//     };
//   }, [navigate, redirectPath]);

//   return (
//     <div className="d-flex flex-column align-items-center justify-content-center vh-100">
//       <h1 className="text-danger">❌ Payment Failed</h1>

//       <p className="mt-2 text-center">{errorMessage}</p>

//       <p className="text-muted">
//         Redirecting back in {seconds} seconds...
//       </p>

//       <div className="d-flex gap-3 mt-4">
//         <button
//           className="btn btn-warning"
//           onClick={() => navigate(redirectPath)}
//         >
//           Retry Payment
//         </button>

//         <button
//           className="btn btn-secondary"
//           onClick={() => navigate(redirectPath)}
//         >
//           Back to Test
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Failure;
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "../PaymentStatus.css";

const Failure: React.FC = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [seconds, setSeconds] = useState(8);

  const errorMessage = (location.state as any)?.message || "Your payment could not be processed. No amount has been deducted.";
  const redirectPath = localStorage.getItem("postLoginRedirect") || "/dashboard";

  useEffect(() => {
    const timer    = setInterval(() => setSeconds(p => p - 1), 1000);
    const redirect = setTimeout(() => navigate(redirectPath), 8000);
    return () => { clearInterval(timer); clearTimeout(redirect); };
  }, [navigate, redirectPath]);

  const REASONS = [
    { icon: "💳", text: "Insufficient balance or card limits" },
    { icon: "🌐", text: "Internet connection interrupted" },
    { icon: "🔒", text: "Bank declined the transaction" },
    { icon: "⏱️", text: "Session timed out during payment" },
  ];

  return (
    <div className="pst-page pst-failure">
      <div className="pst-card">
        {/* Animated X */}
        <div className="pst-icon-wrap pst-icon-failure">
          <svg className="pst-icon-svg" viewBox="0 0 52 52">
            <circle className="pst-circle pst-circle-failure" cx="26" cy="26" r="25" fill="none" strokeWidth="2" />
            <path className="pst-cross" fill="none" strokeWidth="3" strokeLinecap="round" d="M16 16 l20 20 M36 16 l-20 20" />
          </svg>
        </div>

        <h1 className="pst-title pst-title-failure">Payment Failed</h1>
        <p className="pst-subtitle">{errorMessage}</p>

        {/* Possible reasons */}
        <div className="pst-next-steps">
          <div className="pst-next-title">Why this may have happened</div>
          <div className="pst-reasons-grid">
            {REASONS.map(r => (
              <div className="pst-reason-item" key={r.text}>
                <span className="pst-reason-icon">{r.icon}</span>
                <span className="pst-reason-text">{r.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Support note */}
        <div className="pst-support-note">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          If any amount was deducted, it will be automatically refunded within 5–7 business days. Contact <a href="mailto:support@acadebility.com">support@acadebility.com</a> for help.
        </div>

        {/* Countdown */}
        <div className="pst-countdown">
          <div className="pst-countdown-ring pst-countdown-ring-fail" style={{ "--pct": `${(seconds / 8) * 100}%` } as React.CSSProperties}>
            <span className="pst-countdown-num">{seconds}</span>
          </div>
          <span className="pst-countdown-text">Redirecting automatically…</span>
        </div>

        <div className="pst-actions">
          <button className="pst-btn-primary pst-btn-retry" onClick={() => navigate(redirectPath)}>
            Retry Payment →
          </button>
          <Link to="/" className="pst-btn-ghost">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Failure;
